import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { TenantModel } from "../models/tenant.model";
import { ZipModel } from "../models/zip.model";
import { SearchResult } from "../models/search-result.model";
import { VendorModel } from "../models/vendor.model";
import { ProcLinkModel } from "../models/proc-link.model";
import { SetupProcModel } from "../models/setup-proc.model";
import { CodesFileModel } from "../models/codes-file.model";
import { InventInfoModel } from "../models/invent-info.model";
import { OrderItemInfoModel } from "../models/order-item-info.model";
import { RabiesVaccineModel } from "../models/rabies-vaccine.model";
import { ItemCodeModel } from "../models/item-code.model";
import { ItemOrderModel } from "../models/item-code.model";
import { ItemOrderDetailsModel } from "../models/item-code.model";
import { WarningsModel } from "../models/warnings.model";
import { LabTestModel } from "../models/lab-test.model";
import { InvtOrderListModel } from "../models/invt-order-list.model";
import { InvtOrderDetailsModel } from "../models/invt-order-details.model";
import { WhiteGoodItemModel } from "../models/white-goods-item.model";
import { OrderItemListModel } from "../models/white-goods-item.model";
import { CategoryDescListModel } from "../models/category-desc-list.model";
import { WhiteGoodsDetailModel } from "../models/white-goods-detail.model";
import { PetModel } from "../models/pet.model";
import { PetProcsModel } from "../models/pet-proc.model";
import { PetTreatmentModel } from "../models/pet-treatment.model";
import { CouponModel } from "../models/coupon.model";
import { QuickNoteModel } from "../models/quick-note.model";
import { SetupDrugLabelModel } from "../models/setup-drug-label.model";
import { TempPrescModel } from "../models/invoice-model";
import { FilePrescModel } from "../models/file-presc.model";
import { BehaviorSubject } from "rxjs";
import { PODetailModel } from "../models/po-detail.model";
import { ParentGridModel } from "../models/parent-grid.model";
import { ReleaseFormsList, ReleaseFormDetails } from "../models/release-forms.model";
import { ResultHeadingModel } from "../models/result-heading.model";
import { TypesSetupModel } from "../models/types-setup.model";

@Injectable({
    providedIn: "root"
})
export class SetupService {

    private baseUrl: string = 'setup';
    //userData: any = JSON.parse(localStorage['currentUser']);

    zip: ZipModel = new ZipModel('', '', '', '', 0);
    //invent_info: InventInfoModel = new InventInfoModel('','','','',);
    order_item_orden: OrderItemInfoModel = new OrderItemInfoModel('', '', '', 0, '', 0, '', '', 0, 0, '');
    items_order_details: ItemOrderDetailsModel = new ItemOrderDetailsModel(0, '', 0, '', '', '', '', 0, '', 0, '', 0, false, '', false, '', '');
    warning: WarningsModel = new WarningsModel();
    rabies_vaccine: RabiesVaccineModel = new RabiesVaccineModel('', '', '', '', false, '');
    lab_result: LabTestModel = new LabTestModel('', '', '', '', '', '', '', '', '', '');
    invt_order_details: InvtOrderDetailsModel = new InvtOrderDetailsModel(0, '', 0, '', '', '', 0, 0, 0)
    white_goods_detail: WhiteGoodsDetailModel = new WhiteGoodsDetailModel(0, '', '', '', '', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, '', '')
    quick_note: QuickNoteModel = new QuickNoteModel('', '', '');
    setup_druglabel: SetupDrugLabelModel = new SetupDrugLabelModel(0, 0, '', '', 0, 0, 0);
    temp_presc: TempPrescModel = new TempPrescModel(0, 0, '', '', '', 0, '', 0, '', false, '', false, '');
    selected_order_item: PODetailModel = new PODetailModel('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
    selected_parent_item: ParentGridModel = new ParentGridModel('', '', '', 0, '', 0, 0, '', '', '', '', '', '', '', 0, 0, 0, 0, 0, 0, 0, '', 0, 0, '', '', '', '', '', '', false, false, '', '');
    code_no: any = '';

    rabies_vaccines: RabiesVaccineModel[] = []
    vaccine_batchno = [];
    items_code: ItemCodeModel[] = []
    items_order: ItemOrderModel[] = []
    lab_results: LabTestModel[] = []
    lab_result_detail: LabTestModel[] = []
    vendors = [];
    invt_order_list: InvtOrderListModel[] = []
    white_good_item: WhiteGoodItemModel[] = []
    category_desc_list: CategoryDescListModel[] = []
    order_item_list: OrderItemListModel[] = []
    pet: PetModel[] = []
    pet_treatment: PetTreatmentModel[] = []
    coupon: CouponModel[] = []
    releaseform_list: ReleaseFormsList[] = []
    releaseform_details: ReleaseFormDetails = new ReleaseFormDetails(0, false, '', '', '', '', '')
    resultheading_listing: ResultHeadingModel[] = []
    types_setup_list: TypesSetupModel[] = []


    selected_pet_index = 0

    private messageGenericSource = new BehaviorSubject<boolean>(false);
    changeItem = this.messageGenericSource.asObservable();
    vendor_code: string;
    vendor: string;
    item_code: string;
    vendor_visible: string;

    invent_info: InventInfoModel = new InventInfoModel(
        '', // item_no
        '', // code_fix
        '', // code_active
        '', // order_no
        false, // item_tax1
        false, // item_tax2
        false, // item_tax3
        '', // code_category
        '', // code_sub_category
        '', // code_approval
        '', // brief_history_category
        '', // item_presc_code
        '', // code_specie
        false, // item_waste
        '', // unit_price
        '', // item_base_charge
        '', // item_strength
        '', // unit_of_measure
        '', // admin_route
        '', // item_log
        false, // item_warning
        '', // discount_qty
        '', // discount_amount
        '', // smallest_unit
        '', // code_modified_date
        '', // item_class
        '', // item_comm_1
        '', // item_comm_2
        '', // item_comm_3
        '', // price_markup
        '', // admin_location
        0, // qty_on_hand
        0, // reorder_point
        0, // max_stock_level
        '', // qty_month_1
        '', // qty_month_2
        '', // qty_month_3
        '', // qty_month_4
        '', // qty_month_5
        '', // qty_month_6
        '', // qty_month_7
        '', // qty_month_8
        '', // qty_month_9
        '', // qty_month_10
        '', // qty_month_11
        '', // qty_month_12
        '', // qty_this_month
        '', // qty_ytd
        false, // markup_fix
        false, // auto_adjust
        '', // days_supply
        0, // unit_per_issue
        0, // day1
        0, // day2
        0, // day3
        0, // day4
        0, // day5
        0, // day6
        0, // day7
        0, // day8
        0, // day9
        0, // day10
        0, // day11
        0, // day12
        0, // day13
        0, // day14
        0, // day15
        0, // day16
        0, // day17
        0, // day18
        0, // day19
        0, // day20
        0, // day21
        0, // day22
        0, // day23
        0, // day24
        0, // day25
        0, // day26
        0, // day27
        0, // day28
        0, // day29
        0, // day30
        0, // day31
        null, // tag
        null, // item_code
        null, // code_no
        null, // code_type
        null, // code_clinic
        null, // item_desc
        null, // code_name
        '', // manufacturer_code
        [], // codes
        '' // remarks
        ,false
        ,''
        ,''
    );




    constructor(
        private api: ApiService
    ) {
    }

    selectedGenericVar(message: boolean) {
        this.messageGenericSource.next(message)
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }

    GetVaccineBatchNo(vaccine_clinic: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetVaccineBatchNo?vaccine_clinic=${vaccine_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.vaccine_batchno = res.data;
                        resolve(res);
                    } else {
                        this.vaccine_batchno = [];
                        resolve(res);
                    }
                });
        });
        return promise;
    }

    setupVendor(vendor_model: VendorModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupVendor`, vendor_model)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    GetRabieVaccineDetail(vaccine_batch_no: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetRabieVaccineDetail?vaccine_batch_no=${vaccine_batch_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.rabies_vaccine = new RabiesVaccineModel(res.data.vaccine_manuf, res.data.vaccine_type, res.data.vaccine_expire, res.data.vaccine_name, res.data.vaccine_active, res.data.vaccine_use);
                        resolve(1);
                    } else {
                        this.rabies_vaccines = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupRabieVaccine(vaccine_batch_no: string, vaccine_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupRabieVaccine?vaccine_manuf=${this.rabies_vaccine.vaccine_manuf.trim()}&vaccine_type=${this.rabies_vaccine.vaccine_type.trim()}&vaccine_expire=${this.rabies_vaccine.vaccine_expire.trim()}&vaccine_name=${this.rabies_vaccine.vaccine_name.trim()}&vaccine_active=${this.rabies_vaccine.vaccine_active}&vaccine_use=${this.rabies_vaccine.vaccine_use.trim()}&vaccine_batch_no=${vaccine_batch_no.trim()}&vaccine_clinic=${vaccine_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupLinkProc(vendor_model: ProcLinkModel, Indications: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupLinkProc?Indications=${Indications}`, vendor_model)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetItemCodeList(mode: string, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetItemCodeList?mode=${mode}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.items_code = res.data.map((element) => {
                            return new ItemCodeModel(element.item_no, element.item_code, element.item_desc);
                        });
                        resolve(1);
                    } else {
                        this.items_code = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupProc(proc_model: SetupProcModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupProc`, proc_model)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetItemOrder(item_no: number, item_type: number, item_clinic: number, item_code: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetItemOrder?item_no=${item_no}&item_type=${item_type}&item_clinic=${item_clinic}&item_code=${item_code}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.items_order = res.data.map((element) => {
                            return new ItemOrderModel(element.order_no, element.order_code, element.vendor, element.vendor_code, element.item_type, element.vendor_name, element.unit_per_issue, element.issue_container, element.method_of_issue, element.unit_per_container, element.container_type, element._default);
                        });
                        resolve(1);
                    } else {
                        this.items_order = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteLink(proc_model: ProcLinkModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteLink`, proc_model)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateCodeName(proc_model: CodesFileModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateCodeName`, proc_model)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateProcedureDesc(proc_model: CodesFileModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateProcedureDesc`, proc_model)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getInventInfo(item_code: string = '', item_desc: string = '', code_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getInventInfo?item_code=${item_code}&item_desc=${item_desc}&code_clinic=${code_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.invent_info = res.data;
                        // this.invent_info.item_tax1 = this.invent_info.item_tax1 === "True";
                        // this.invent_info.item_tax2 = this.invent_info.item_tax2 === "True";
                        // this.invent_info.item_tax3 = this.invent_info.item_tax3 === "True";
                        // this.invent_info.markup_fix = this.invent_info.markup_fix === "True";
                        // this.invent_info.item_waste = this.invent_info.item_waste === "True";
                        // this.invent_info.item_warning = this.invent_info.item_warning === "True";
                        // this.invent_info.auto_adjust = this.invent_info.auto_adjust === "True";
                        this.invent_info.unit_per_issue = Number(this.invent_info.unit_per_issue);
                        this.invent_info.order_no = Number(this.invent_info.order_no);

                        if (this.invent_info.code_fix === 'F' || this.invent_info.code_fix === 'S') {
                            this.invent_info.qty_on_hand = Number(this.invent_info.qty_on_hand) / (this.invent_info.unit_per_issue === 0 ? 1 : this.invent_info.unit_per_issue);
                            this.invent_info.reorder_point = Number(this.invent_info.reorder_point) / (this.invent_info.unit_per_issue === 0 ? 1 : this.invent_info.unit_per_issue);
                            this.invent_info.max_stock_level = Number(this.invent_info.max_stock_level) / (this.invent_info.unit_per_issue === 0 ? 1 : this.invent_info.unit_per_issue);
                        }

                        console.log(this.invent_info);
                        resolve(res);
                    } else {
                        //this.invent_info = new InventInfoModel();
                        resolve(res);
                    }
                });
        });
        return promise;
    }

    GetItemOrderDetails(order_no: number, _default: boolean) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetItemOrderDetails?order_no=${order_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.items_order_details = new ItemOrderDetailsModel(res.data.order_no, res.data.order_code, res.data.item_no, res.data.item_type, res.data.vendor, res.data.vendor_code,
                            res.data.method_of_issue, res.data.unit_per_issue, res.data.issue_container, res.data.unit_per_container, res.data.container_type, res.data.container_cost, res.data.order_item_active
                            , res.data.order_item_modified_date, _default, '', res.data.manufacturer_code);
                        resolve(1);
                    } else {
                        this.items_order_details = new ItemOrderDetailsModel(0, '', 0, '', '', '', '', 0, '', 0, '', 0, false, '', false, '', '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetVendorCodeList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetVendorCodeList`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.vendors = res.data;
                        resolve(res);
                    } else {
                        this.vendors = [];
                        resolve(res);
                    }
                });
        });
        return promise;
    }

    getOrderItemOrder(order_no: string | number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getOrderItemOrder?order_no=${order_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.order_item_orden = res.data;
                        resolve(res);
                    } else {
                        this.order_item_orden = new OrderItemInfoModel('', '', '', 0, '', 0, '', '', 0, 0, '');
                        resolve(res);
                    }
                });
        });
        return promise;
    }

    getWarnings(item_no: string | number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getWarnings?item_no=${item_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.warning = res.data;
                        resolve(res);
                    } else {
                        this.warning = new WarningsModel();
                        resolve(res);
                    }
                });
        });
        return promise;
    }

    setupInventoryInfo(invent_info: InventInfoModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupInventoryInfo`, invent_info)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupOrderItem() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupOrderItem`, this.items_order_details)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getLabTest() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getLabTest`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.lab_results = res.data
                        resolve(1);
                    } else {
                        this.lab_results = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetInventoryCodesList(code_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInventoryCodesList?code_clinic=${code_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.invt_order_list = res.data.map((element) => {
                            return new InvtOrderListModel(element.code_no, element.code_name, element.item_desc);
                        });
                        resolve(1);
                    } else {
                        this.invt_order_list = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getLabTestDetail(lab_test: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getLabTestDetail?lab_test=${lab_test}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.lab_result_detail = res.data
                        resolve(1);
                    } else {
                        this.lab_result_detail = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetInventoryCodesDetails(code_clinic: number, code_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetInventoryCodesDetails?code_clinic=${code_clinic}&code_no=${code_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.invt_order_details = new InvtOrderDetailsModel(res.data.code_no, res.data.item_desc, res.data.qty_on_hand, res.data.code_fix, res.data.method_of_issue, res.data.issue_container, res.data.unit_per_issue,
                            res.data.container_cost, res.data.unit_per_container);
                        resolve(1);
                    } else {
                        this.invt_order_details = new InvtOrderDetailsModel(0, '', 0, '', '', '', 0, 0, 0);
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupLabTest() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupLabTest`, this.lab_result)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupInsertInventoryCodes(item_no: number, item_type: number, item_clinic: number, location: string, employees: string, quantity: number, container: string, count_date: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupInsertInventoryCodes?item_no=${item_no}&item_type=${item_type}&item_clinic=${item_clinic}&location=${location}&employees=${employees}&quantity=${quantity}&container=${container}&count_date=${count_date}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    upDownLabTest(item: LabTestModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/upDownLabTest`, item)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupUpdateInventoryCodes(item_no: number, item_clinic: number, quantity: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupUpdateInventoryCodes?item_no=${item_no}&item_clinic=${item_clinic}&quantity=${quantity}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetWhiteGoodItemList(item_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetWhiteGoodItemList?item_clinic=${item_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.white_good_item = res.data.map((element) => {
                            return new WhiteGoodItemModel(element.item_no, element.item_code, element.item_desc);
                        });
                        resolve(1);
                    } else {
                        this.white_good_item = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    GetCategoryDescList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetCategoryDescList`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.category_desc_list = res.data.map((element) => {
                            return new CategoryDescListModel(element.category_no, element.category_code);
                        });
                        resolve(1);
                    } else {
                        this.category_desc_list = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetWhiteGoodsDetail(item_no: number, item_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetWhiteGoodsDetail?item_no=${item_no}&item_clinic=${item_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.white_goods_detail = new WhiteGoodsDetailModel(res.data.item_no, res.data.item_code, res.data.item_desc, res.data.item_category, res.data.code_active, res.data.order_no, res.data.reorder_qty,
                            res.data.qty_ytd, res.data.qty_this_month, res.data.qty_month_1, res.data.qty_month_2,
                            res.data.qty_month_3, res.data.qty_month_4, res.data.qty_month_5, res.data.qty_month_6,
                            res.data.qty_month_7, res.data.qty_month_8, res.data.qty_month_9, res.data.qty_month_10,
                            res.data.qty_month_11, res.data.qty_month_12, res.data.item_unit, res.data.item_modified_date);
                        resolve(1);
                    } else {
                        this.white_goods_detail = new WhiteGoodsDetailModel(0, '', '', '', '', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, '', '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getOrderItemByItemNo(item_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getOrderItemByItemNo?item_no=${item_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.order_item_list = res.data.map((element) => {
                            return new OrderItemListModel(element.order_no, element.order_code);
                        });
                        resolve(1);
                    } else {
                        this.order_item_list = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPetTreatment(clinic_no: number, tag_no_initial: string, tag_no_ending: string, discharge_time_initial: string, discharge_time_ending: string, clinic_dept: string, procedures: string, status: string, page_number: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post<SearchResult>(`${this.baseUrl}/GetPetTreatment?clinic_no=${clinic_no}&tag_no_initial=${tag_no_initial}&tag_no_ending=${tag_no_ending}&discharge_time_initial=${discharge_time_initial}&discharge_time_ending=${discharge_time_ending}&clinic_dept=${clinic_dept}&procedures=${procedures}&status=${status}&page_number=${page_number}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.pet_treatment = res.data.map((element) => {
                            return new PetTreatmentModel(element.pet, element.procs);
                        });

                        console.log(this.pet_treatment)
                        resolve(1);
                    } else {
                        this.pet_treatment = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupWhiteGoods(ItemNo: number, item_code: string, code_active: string, code_clinic: number, item_active: boolean, item_category: string, code_sub_category: string, item_desc: string, item_unit: string, order_no: number, reorder_qty: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupWhiteGoods?ItemNo=${ItemNo}&item_code=${item_code}&code_active=${code_active}&code_clinic=${code_clinic}&item_active=${item_active}&item_category=${item_category}&code_sub_category=${code_sub_category}&item_desc=${item_desc}&item_unit=${item_unit}&order_no=${order_no}&reorder_qty=${reorder_qty}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetCoupon(clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetCoupon?clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.coupon = res.data.map((element) => {
                            return new CouponModel(element.coupon_no, element.coupon_name, element.last_clear_date, element.date_added, element.active, element.clinic_no);
                        });
                        resolve(1);
                    } else {
                        this.coupon = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupQuickNote() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupQuickNote`, this.quick_note)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupDrugLabel() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupDrugLabel`, this.setup_druglabel)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupDrugNote() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupDrugNote`, this.setup_druglabel)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupTempPresc() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupTempPresc`, this.temp_presc)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupFilePresc(model: FilePrescModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupFilePresc`, model)
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    getReleaseFormsList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetReleaseFormsList?role_no=${this.userData.role_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.releaseform_list = res.data.map((element) => {
                            return new ReleaseFormsList(element.id, element.form_name, element.edit_access);
                        });
                        resolve(1);
                    } else {
                        this.releaseform_list = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupReleaseForms() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupReleaseForms`, this.releaseform_details)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetReleaseFormsDets() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetReleaseFormsDets?id=${this.releaseform_details.id}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.releaseform_details = new ReleaseFormDetails(res.data.id, res.data.pet_det, res.data.procedures, res.data.prompt, res.data.form_name, '', res.data.role_access);
                        resolve(1);//id: number, pet_det: boolean, procedures: string, prompt: string, form_name: string
                    } else {
                        this.releaseform_details = new ReleaseFormDetails(0, false, '', '', '', '', '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupWarning(item_no, item_warnings, action) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupWarning?item_no=${item_no}&item_warnings=${item_warnings}&action=${action}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getResultHeading(result_proc: number, result_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetResultHeading?result_proc=${result_proc}&result_clinic=${result_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.resultheading_listing = res.data.map((element) => {
                            return new ResultHeadingModel(element.result_proc, element.result_sequence, element.result_name, element.result_clinic);
                        });
                        resolve(1);
                    } else {
                        this.resultheading_listing = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //DeleteResultHeading(int result_proc, int result_clinic)
    DeleteResultHeading(result_proc: number, result_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/DeleteResultHeading?result_proc=${result_proc}&result_clinic=${result_clinic}`)
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }


    SetupResultHeading(result_name_group: string[], result_proc: number, result_clinic: number) {
        let item = {
            result_name_group: result_name_group,
            result_proc: result_proc,
            result_clinic: result_clinic,
            result_sequence: 0,
            result_name: ''
        }
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupResultHeading`, item)
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    GetTypesList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetTypesList`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.types_setup_list = res.data.map((element) => {
                            return new TypesSetupModel(element.typeid, element.typecode, element.description, element.category, element.categoryid, element.typedescription);
                        });
                        resolve(1);
                    } else {
                        this.types_setup_list = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //SetupTypes([FromBody] TypesSetupModel model, int actionType)
    SetupTypes(model: TypesSetupModel, actionType: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupTypes?actionType=${actionType}`, model)
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    DeleteType(typeid: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/DeleteType?typeid=${typeid}`)
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    



}